// extracted by mini-css-extract-plugin
module.exports = {"unifiedButton":"UnifiedButtonPDP_unifiedButton__F5y9s","slide-in-out":"UnifiedButtonPDP_slide-in-out__PLhK_","fade-in-out":"UnifiedButtonPDP_fade-in-out__GzmeL"};